// extracted by mini-css-extract-plugin
export default {"toggle":"ModeToggle_toggle__shyLF","checkbox":"ModeToggle_checkbox__D0YCp","label":"ModeToggle_label__b9Jj5","sun":"ModeToggle_sun__rRp12","moon":"ModeToggle_moon__vVWj6"};